<template>
    <div class="form__date__inner" v-bind="$attrs" style="cursor: pointer" @click="datePicker.show()">
            <div>

                <label for="start_date">
                    <small>Check In</small>
                </label>

                <span id="start-date-val">Add Date</span>
                <svg class="arrow-down">
                    <use xlink:href="#arrow-down"></use>
                </svg>

                <input type="text" id="start_date" name="start_date" class="required" placeholder="Check In" />
            </div>
            <div>

                <label for="end_date">
                    <small>Check Out</small>
                </label>

                <span id="end-date-val">Add Date</span>
                <svg class="arrow-down">
                    <use xlink:href="#arrow-down"></use>
                </svg>

                <input type="text" id="end_date" name="end_date" class="required" placeholder="Check Out" />
            </div>
    </div>
</template>
<script>
const lightPick = require('lightpick');
export default {

    props:{
        value:{
            required: false,
            default: null,
        }
    },

    data() {
        return {
            datePicker: null,
        }
    },

    mounted() {
        this.createDatePicker()
    },

    methods: {
        createDatePicker() {
            this.datePicker = new lightPick({
                field: document.getElementById('start_date'),
                secondField: document.getElementById('end_date'),
                format: 'MM-DD-YYYY',
                selectForward: true,
                minDate: new Date(),
                onSelect: (start, end) => {

                    let _start = $('#start_date').val()
                    let _end = $('#end_date').val()

                    if (_start) {
                        $('#start-date-val').text(_start);
                    }

                    if (_end) {
                        $('#end-date-val').text(_end);
                    }

                    if (start && end) {
                        this.$emit('input', {
                            start_date: start.format('Y-MM-DD'),
                            end_date: end.format('Y-MM-DD')
                        })
                        this.$emit('change', {
                            start_date: start.format('Y-MM-DD'),
                            end_date: end.format('Y-MM-DD')
                        })
                    }
                }
            })
        }
    }
}
</script>
